import React, { useState, useEffect } from 'react';
import { AlertCircle, Shield } from 'lucide-react';
import { ethicsReviewService } from '../services/api';

function EthicsReview() {
  const [ethicsReview, setEthicsReview] = useState({
    principles: '',
    prohibitedItems: '',
    process: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEthicsReview = async () => {
      try {
        const response = await ethicsReviewService.get();
        if (response.data) {
          setEthicsReview({
            principles: response.data.principles || '',
            prohibitedItems: response.data.prohibitedItems || '',
            process: response.data.process || '',
          });
        }
      } catch (error) {
        console.error('Error fetching ethics review:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchEthicsReview();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">بررسی اخلاقی</h1>
          <p className="text-xl text-blue-100">استانداردهای اخلاقی و بررسی مقالات</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        {ethicsReview.principles && (
          <section className="bg-white rounded-xl shadow-md p-8 mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <Shield className="text-blue-700" size={28} />
              اصول اخلاقی
            </h2>
            <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
              {ethicsReview.principles}
            </div>
          </section>
        )}

        {ethicsReview.prohibitedItems && (
          <section className="bg-white rounded-xl shadow-md p-8 mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <AlertCircle className="text-red-600" size={28} />
              موارد ممنوع
            </h2>
            <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
              {ethicsReview.prohibitedItems}
            </div>
          </section>
        )}

        {ethicsReview.process && (
          <section className="bg-blue-50 rounded-xl border-r-4 border-blue-700 p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">فرآیند بررسی اخلاقی</h2>
            <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
              {ethicsReview.process}
            </div>
          </section>
        )}

        {!ethicsReview.principles && !ethicsReview.prohibitedItems && !ethicsReview.process && (
          <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
            <p>اطلاعاتی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default EthicsReview;
